module.exports = __webpack_public_path__ + "img/ydkt.e303353b.png";